import React, { useEffect, useState } from "react";
import { Card, InputAnswerArea } from "./StyledComponent"; // Assuming AnswerArea is not used here

const Operation = ({
    item,
    data,
    current,
    setUserAnswer,
    // handleDrag, handleDragOver props are not used in the new click-only logic
}) => {
    // consigneValues will store objects like: 
    // { value: "static_part", userValue: "" } 
    // or { value: "answer_placeholder", userValue: "selected_number" }
    const [consigneValues, setConsigneValues] = useState([]);

    // Initialize/Reset consigneValues based on item.consigne
    useEffect(() => {
        if (item?.consigne) {
            const values = item.consigne.map((consigneItem) => {
                try {
                    const parsed = JSON.parse(consigneItem);
                    // Ensure a userValue key exists for tracking the user's choice
                    return { ...parsed, userValue: "" }; 
                } catch (error) {
                    // This handles non-JSON elements (like operators or static numbers)
                    return { value: consigneItem, userValue: "" }; 
                }
            });
            setConsigneValues(values);
        } else {
            setConsigneValues([]);
        }
    }, [item]);


    const handleCardClick = (cardValue) => {
        const updatedValues = [...consigneValues];
        
        // 1. Find the index of the first object that represents an answer area (isCorrectPlace) 
        // AND has an empty userValue.
        const firstEmptyAnswerIndex = updatedValues.findIndex((consigne) => {
            const isAnswerPlaceholder = data[current]?.correction_dp?.includes(consigne.value);
            return isAnswerPlaceholder && consigne.userValue === "";
        });

        if (firstEmptyAnswerIndex !== -1) {
            // 2. If an empty slot is found, fill it with the cardValue
            updatedValues[firstEmptyAnswerIndex] = {
                ...updatedValues[firstEmptyAnswerIndex],
                userValue: cardValue,
            };
        } else {
             // OPTIONAL: If all are filled, clicking a card could clear the *last* filled value 
             // or do nothing. For sequential filling, we usually do nothing or focus on clearing.
             console.log("All answer slots are filled.");
             return; 
        }

        // 3. Update state and the overall user answer
        setConsigneValues(updatedValues);
        
        const newAnswers = updatedValues
            .filter(c => data[current]?.correction_dp?.includes(c.value) && c.userValue !== "")
            .map(c => c.userValue);
            
        setUserAnswer(newAnswers);
    };

    // Handler to remove a value by clicking the input field itself (optional but helpful)
    const handleInputClick = (index) => {
        const updatedValues = [...consigneValues];
        // Only clear if it's an answer placeholder and has a value
        if (data[current]?.correction_dp?.includes(updatedValues[index].value) && updatedValues[index].userValue) {
            updatedValues[index] = {
                ...updatedValues[index],
                userValue: "",
            };
            setConsigneValues(updatedValues);
            
            const newAnswers = updatedValues
                .filter(c => data[current]?.correction_dp?.includes(c.value) && c.userValue !== "")
                .map(c => c.userValue);
                
            setUserAnswer(newAnswers);
        }
    };


    if (!item || !item.consigne || !Array.isArray(item.consigne)) {
        return <div>Invalid operation data</div>;
    }

    // Determine which choices have already been used to style the cards
    const usedChoices = consigneValues
        .filter(c => c.userValue)
        .map(c => c.userValue);

    return (
        <div>
            <p className="py-4">Résolvez l'opération (cliquer sur la bonne réponse) :</p>
            <div className="flex gap-4 flex-wrap items-center justify-center">
                {consigneValues.map((consigne, index) => {
                    // Check if this consigne item is one of the answer placeholders
                    const isAnswerPlaceholder = data[current]?.correction_dp?.includes(consigne.value);

                    return isAnswerPlaceholder ? (
                        <InputAnswerArea
                            key={index}
                            // *** FIX: Display the userValue for THIS specific item ***
                            value={consigne.userValue || ""} 
                            className="mb-3 p-2"
                            readOnly
                            placeholder=""
                            onClick={() => handleInputClick(index)} // Allow clearing by clicking
                            style={{ 
                                borderColor: consigne.userValue ? '#003B7F' : '#ccc'
                            }}
                        />
                    ) : (
                        // Render the static part of the operation (like numbers, operators)
                        <Card key={index}>
                            {consigne.value}
                        </Card>
                    );
                })}
            </div>
            
            <div className="flex gap-4 flex-wrap items-center justify-center mt-44">
                {item?.choices?.map((choice, index) => {
                    const isUsed = usedChoices.includes(choice);
                    
                    return (
                        <Card
                            key={index}
                            onClick={() => handleCardClick(choice)}
                            // Prevent clicking a choice card if it's already used
                            // Note: You might want to allow re-using the same number if needed
                            // style={{ opacity: isUsed ? 0.5 : 1, pointerEvents: isUsed ? 'none' : 'auto' }}
                            style={{
                                borderColor: isUsed ? "#003B7F" : "#ccc",
                            }}
                        >
                            {choice}
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default Operation;